import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'

export function useAuth() {
  const { data: user, isLoading, error } = useQuery({
    queryKey: ['auth', 'user'],
    queryFn: () => api.getCurrentUser(),
    retry: false,
    staleTime: 1000 * 60 * 10, // 10 minutes
  })

  return {
    user,
    isAuthenticated: !!user && !error,
    isLoading,
    error,
  }
}
